export const components = {
	infoBanner: {
		tipError: {
			title: "Não foi possível concluir o cadastro.",
			description: "Revise os campos preenchidos ou tente de novo em alguns minutos.",
		},
	},
};
